import CodeTaskTypeList from "./pages/ListPage.vue";
import CodeTaskTypeDetail from "./pages/FormPage.vue";
import CodeTaskTypeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_task_type",
    component: CodeTaskTypeIndex,
    redirect: "/code_task_type/list",
    name: "code_task_type",
    children: [
      {
        path: "list",
        component: CodeTaskTypeList,
        name: "code_task_type.list",
      },
      {
        path: "create",
        component: CodeTaskTypeDetail,
        name: "code_task_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeTaskTypeDetail,
        name: "code_task_type.edit",
        props: { create: false },
      },
    ],
  },
];
